import { Route, Routes } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { ProtectedRoute } from '../components/auth/protected-route';
import { Layout } from '../components/layout/layout';
import Diagnostics from '../pages/diagnostics';
import Login from '../pages/login/login';
import LoginRedirect from '../pages/login/redirect';
import NotPermission from '../pages/not-permission-page';
import ResetPassword from '../pages/reset-password/reset-password';
import Settings from '../pages/settings';
import CookiePolicy from '../pages/terms-of-use/cookie';
import TermsOfUse from '../pages/terms-of-use';
import PrivacyPolicy from '../pages/terms-of-use/privacy';

const GroupedRoutes = () => {
  return (
    <Routes>
      <Route path="/not-permission" element={<NotPermission />} />
      <Route path="/dashboard" element={<ProtectedRoute component={Layout} />} />

      {/* Standalone, unprotected on purpose (IM-2465): the diagnostics page must
          load even when the session or app state is broken — that is when it is
          most useful. It reports auth status rather than gating on it. */}
      <Route path="/diagnostics" element={<Diagnostics />} />

      <Route path="/login" element={<Login />} />
      <Route path="/login/redirect" element={<LoginRedirect />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/terms-of-use"
        element={<ProtectedRoute component={TermsOfUse} returnUrl="/terms-of-use" />}
      />
      <Route
        path="/privacy-policy"
        element={<ProtectedRoute component={PrivacyPolicy} returnUrl="/privacy-policy" />}
      />
      <Route
        path="/cookie-policy"
        element={<ProtectedRoute component={CookiePolicy} returnUrl="/cookie-policy" />}
      />
      <Route
        path="/settings"
        element={<ProtectedRoute component={Settings} returnUrl="/settings" />}
      />

      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default GroupedRoutes;
